export { locale } from './locale';

export {
    isFromCourseMiniApp,
    isGroupUrl,
    openCourseInMp,
    getMiniAppSdk,
    addMiniAppOriginToUrl,
    openUrlInMp,
} from 'common/src/services/util';

export { LANG, DisableAppShareButton } from './webview';

export { isSupportRecord } from './record';

export { uploadImageToServer, choosePhotoByApp, choosePhotoByWx } from './imgUploadUtil';

export { getRecaptchaJsUri, setRecaptchaJsLoaded, getRecaptchaJsLoaded } from './recaptcha';

export { rotateImg, getBosUrlRotateSum, getAwsUrlRotateSum } from './imgRotateUtil';
export { getSocketUrl } from './config';

export { postMessageWithOldTab, postMessageWithOtherTab } from './postMessageWithNewTab';

/**
 *
https://dev14.umucdn.cn/course/?groupId=6799911&sKey=7d7a
https://m.dev14.umucdn.cn/course/?groupId=6799911&sKey=7d7a&isMobilePreview=1
 *
*/
// 判断当前链接是否为课程链接
export const isCourseLink = (link: string) => {
    // 获取链接的路径名，并检查其是否以 '/course/' 结尾
    try {
        const url = new URL(link);
        return url.pathname.endsWith('/course/');
    } catch (e) {
        return false;
    }
};
// 将PC端课程链接转换为移动端课程链接
export const courseLinkPcToMobile = (link: string) => {
    try {
        const url = new URL(link);
        // 处理 host 部分以加入 'm.'
        let host = url.host;
        if (host.startsWith('test.')) {
            host = host.replace('test.', 'test.m.');
        } else {
            host = 'm.' + host;
        }

        url.host = host;

        // 添加参数 'isMobilePreview=1'
        url.searchParams.set('isMobilePreview', '1');
        return url.toString();
    } catch (_e) {
        return link;
    }
};

export const isProgramLink = (link: string) => {
    // https://dev14.umucdn.cn/program/buv5b96/detail
    // https://m.dev14.umucdn.cn/program/buv5b96
    try {
        const url = new URL(link);
        const regex = /^\/program\/[a-zA-Z0-9]+(\/detail)?$/;
        return regex.test(url.pathname);
    } catch (e) {
        return false;
    }
};
export const programLinkPcToMobile = (link: string) => {
    try {
        const url = new URL(link);
        let host = url.host;
        if (host.startsWith('test.')) {
            host = host.replace('test.', 'test.m.');
        } else {
            host = 'm.' + host;
        }
        url.host = host;
        url.pathname = url.pathname.replace('/detail', '');
        url.searchParams.set('isMobilePreview', '1');
        return url.toString();
    } catch (_e) {
        return link;
    }
};
export const isSessionLink = (link: string) => {
    //  https://dev14.umucdn.cn/ssu_2yCw98c2a
    try {
        const url = new URL(link);
        const regex = /^\/ssu_[a-zA-Z0-9]+$/;
        return regex.test(url.pathname);
    } catch (e) {
        return false;
    }
};
export const sessionLinkPcToMobile = (link: string) => {
    try {
        const url = new URL(link);
        // 处理 host 部分以加入 'm.'
        let host = url.host;
        if (host.startsWith('test.')) {
            host = host.replace('test.', 'test.m.');
        } else {
            host = 'm.' + host;
        }

        url.host = host;

        // 添加参数 'isMobilePreview=1'
        url.searchParams.set('isMobilePreview', '1');
        return url.toString();
    } catch (_e) {
        return link;
    }
};

export * from './webview';

/**
 * userAchievementUtil
 */
export {
    getUserLevelColorScheme,
    displayUserLevel,
    isFullUserLevel,
    FULL_USER_LEVEL,
    getDefaultAvatar,
} from './userAchievementUtil';

export {
    getRootScale,
    getRootFontSize,
    isLogin,
    transformRemToPx,
    getFontSizeSwitchList,
    getCurrentFontSize,
    transformPxValueToRem,
    getCurrentFontSizeValue,
    transformPx2Rem,
    updateFontSize,
    isCanShowFontSizeSwitch,
} from './fontSize';

export { requestIdleCallback } from './polyfill';

export {
    getEnterpriseId,
    getEnterpriseEnrollInfo,
    isUrlEncoded,
    getLoginUrl,
    gotoLogin,
    gotoRegist,
    base64Image,
    shuffle,
    getShuffleThemeList,
    pinUrl,
    getWindowParentUrl,
    checkXFrameAllow,
    unescapeStr,
    checkLogin,
    getPageStartFrom,
    isFromLive,
    isInMiniProgram,
    isMiniProgram,
    formatDownloadUrl,
    formatHomeworkSectionList,
    onWeights,
    getEnterprisePollList,
    onTransformHomeworkSectionList,
    getTotalScoreByParentType,
    translateStatNum,
    getDownloadUrl,
    downloadResourceFile,
    downloadByAnchor,
    downloadByAnchorWithCallback,
    downloadByIFrame,
    downloadImgByAnchor,
    downloadImgByBlob,
    downloadQr,
    getIOSAppDownloadUrl,
    getAndroidAppDownloadUrl,
    getDurationObj,
    getHourMinuteSecond,
    getHourMinuteSecondNum,
    getAccessUrl,
    getCharacterLength,
    getCircleIndexUrl,
    getCurrencySuffix,
    getCurrencySymbol,
    crrencySymbol,
    getFactFromUrl,
    getGroupCardCount,
    getLimitCharacterStr,
    getLocalSymbol,
    getMHost,
    getOddCharacterLength,
    getPageTitle,
    getPinUrl,
    getProgramCardCount,
    getTenantIdFromUrl,
    UrlFrom,
    getUrlFrom,
    numToThousands,
    isEnableScormApiForCompletion,
    isEnterprise,
    isInPinIFrame,
    isThatDay,
    isUmuUrl,
    shieldAppShare,
    showAppShare,
    SECTION_COLOR_SCHEME_TOTAL,
    TENAND_ID,
    buildTenantIdQuery,
    WechatFollowLink,
    postThrottle,
    toUmuFixed,
    upgradeUMUApp,
    downLinkByWeb,
    getMinuteSecondNum,
} from './umuUtil';

export function removeElementsByClass(className: string) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
        if (elements[0] && elements[0].parentNode) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    }
}

/**
 * @desc 十六进制颜色转RGB
 */
export function hexToRgb(hex: string) {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
}

/**
 * @desc 依据边框颜色修改样式变量从而改变字体和背景颜色
 */
export const onSetColorByBorder = (
    cls: string,
    config: {
        borderVar: string;
        colorVar: string;
        mapColor?: Record<string, string>;
    },
) => {
    const root: any = document.querySelector(`.${cls}`);
    if (root) {
        const borderColor = getComputedStyle(root).getPropertyValue(config.borderVar).trim() || '#FAB400';
        const [r, g, b] = hexToRgb(borderColor);
        root.style.setProperty(`${config.borderVar}-r`, r);
        root.style.setProperty(`${config.borderVar}-g`, g);
        root.style.setProperty(`${config.borderVar}-b`, b);
        config.colorVar && root.style.setProperty(config.colorVar, config.mapColor?.[borderColor] || borderColor);
    }
};

export const getIsMicroPageLink = (link: string) => {
    return /\/micro-pages\/[a-zA-Z0-9]{24}(\/EDITOR)?$/.test(link);
};

export { normalizeAccountName, normalizeAccountEPU } from './normalizeAccount';
